/** Only bounded pixel values reach inline styles; absent values keep responsive defaults. */
export function normalizeWidgetStyling(value) {
    const source = value && typeof value === 'object' && !Array.isArray(value)
        ? value : {};
    const pixel = (key, min, max) => {
        const number = source[key];
        return typeof number === 'number' && Number.isInteger(number) && number >= min && number <= max
            ? number : undefined;
    };
    return {
        popupBorderRadiusPx: pixel('popupBorderRadiusPx', 0, 128),
        popupPaddingPx: pixel('popupPaddingPx', 0, 48),
        popupMaxWidthPx: pixel('popupMaxWidthPx', 160, 640),
        popupFontSizePx: pixel('popupFontSizePx', 10, 32),
        closeButtonBorderRadiusPx: pixel('closeButtonBorderRadiusPx', 0, 32),
        closeButtonSizePx: pixel('closeButtonSizePx', 32, 64),
        launcherBorderRadiusPx: pixel('launcherBorderRadiusPx', 0, 256),
    };
}
